import React from "react";

const DrawerError = () => {
  return (
    <svg
      width="162"
      height="172"
      viewBox="0 0 162 172"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M103.686 0H31.5262C23.1863 0.00444745 15.1896 3.29549 9.29399 9.14957C3.39838 15.0037 0.0864246 22.9416 0.0864258 31.2183V135.039L31.7797 112.711H103.686C112.026 112.707 120.022 109.416 125.918 103.562C131.814 97.7077 135.125 89.7698 135.125 81.4931V31.168C135.112 22.9 131.794 14.975 125.9 9.13176C120.006 3.28855 112.017 0.00443203 103.686 0Z"
        fill="url(#paint0_linear_10664_23905)"
      />
      <path
        d="M67.5876 23C60.9605 23 54.482 24.9657 48.9723 28.6483C43.4626 32.3309 39.1687 37.5648 36.6343 43.6882C34.0999 49.8115 33.4388 56.5488 34.7343 63.0481C36.0298 69.5473 39.2236 75.5163 43.9122 80.1998C48.6008 84.8834 54.5734 88.071 61.0741 89.3595C67.5747 90.6481 74.3112 89.9797 80.4318 87.4387C86.5524 84.8977 91.7821 80.5984 95.4587 75.0847C99.1354 69.571 101.094 63.0907 101.087 56.4636C101.077 47.5852 97.5438 39.0738 91.2625 32.7992C84.9812 26.5246 76.466 23 67.5876 23Z"
        fill="#00FFFC"
      />
      <path
        d="M67.5861 23C60.959 23 54.4806 24.9657 48.9708 28.6483C43.4611 32.3309 39.1673 37.5648 36.6328 43.6882C34.0984 49.8115 33.4373 56.5488 34.7328 63.0481C36.0283 69.5473 39.2221 75.5163 43.9107 80.1998C48.5993 84.8834 54.572 88.071 61.0726 89.3595C67.5732 90.6481 74.3097 89.9797 80.4303 87.4387C86.5509 84.8977 91.7806 80.5984 95.4573 75.0847C99.1339 69.5711 101.093 63.0907 101.085 56.4636C101.076 47.5852 97.5424 39.0738 91.261 32.7992C84.9797 26.5246 76.4645 23 67.5861 23ZM82.6661 66.3015C83.0248 66.6374 83.3108 67.0433 83.5063 67.4941C83.7018 67.945 83.8026 68.4313 83.8026 68.9227C83.8026 69.4142 83.7018 69.9003 83.5063 70.3512C83.3108 70.802 83.0248 71.2079 82.6661 71.5438C81.9583 72.2453 81.0056 72.6444 80.0091 72.6568C79.5194 72.6598 79.0341 72.5627 78.5834 72.3713C78.1326 72.1798 77.726 71.8982 77.3881 71.5438L67.5861 61.7417L57.7836 71.5438C57.0759 72.2453 56.1232 72.6444 55.1267 72.6568C54.637 72.6598 54.1521 72.5627 53.7013 72.3713C53.2506 72.1798 52.8436 71.8982 52.5057 71.5438C52.1469 71.2079 51.861 70.802 51.6655 70.3512C51.47 69.9003 51.3692 69.4142 51.3692 68.9227C51.3692 68.4313 51.47 67.945 51.6655 67.4941C51.861 67.0433 52.1469 66.6374 52.5057 66.3015L62.3077 56.4636L52.5057 46.6616C52.1615 46.315 51.889 45.904 51.7036 45.4521C51.5182 45.0002 51.4236 44.5163 51.4253 44.0278C51.427 43.5394 51.5248 43.056 51.7132 42.6054C51.9017 42.1547 52.1771 41.7456 52.5236 41.4014C52.8702 41.0572 53.2814 40.7847 53.7333 40.5993C54.1852 40.4139 54.6689 40.3193 55.1574 40.321C55.6458 40.3226 56.1294 40.4205 56.5801 40.6089C57.0307 40.7974 57.4394 41.0728 57.7836 41.4193L67.5861 51.2216L77.3881 41.4193C77.7323 41.0728 78.1415 40.7974 78.5921 40.6089C79.0427 40.4205 79.5259 40.3226 80.0144 40.321C80.5028 40.3193 80.9869 40.4139 81.4388 40.5993C81.8907 40.7847 82.3015 41.0572 82.6481 41.4014C82.9947 41.7456 83.2701 42.1547 83.4585 42.6054C83.647 43.056 83.7448 43.5394 83.7465 44.0278C83.7481 44.5163 83.6535 45.0002 83.4682 45.4521C83.2828 45.904 83.0103 46.315 82.6661 46.6616L72.8281 56.4636L82.6661 66.3015Z"
        fill="#00033A"
      />
      <g clip-path="url(#clip0_10664_23905)">
        <path
          d="M129.504 53.0607L128.754 49.6507C127.231 50.6554 125.912 51.9377 124.864 53.4307C123.434 55.6607 122.744 61.6007 122.334 61.8207C121.924 62.0407 117.394 55.0607 116.604 53.9607C115.826 52.6441 115.157 51.2662 114.604 49.8407C113.994 48.6607 111.834 48.2507 111.014 48.4007C110.194 48.5507 112.134 52.0207 112.134 52.0207C112.134 52.0207 117.054 60.5607 118.694 65.2407C120.334 69.9207 125.444 72.1407 126.264 71.4707C127.084 70.8007 129.504 53.0607 129.504 53.0607Z"
          fill="url(#paint1_linear_10664_23905)"
        />
        <path
          d="M114.584 50.4994C114.584 50.4994 114.384 49.5994 113.824 49.4094C113.306 49.3036 112.772 49.3036 112.254 49.4094C111.871 49.2462 111.497 49.0625 111.134 48.8594L112.014 50.4994C112.014 50.4994 113.724 52.4994 114.294 51.7594C114.864 51.0194 114.584 50.4994 114.584 50.4994Z"
          fill="url(#paint2_linear_10664_23905)"
        />
        <path
          d="M110.824 48.9395C110.551 50.1921 110.397 51.4678 110.364 52.7495C110.514 53.4095 110.914 53.0595 110.984 52.9095C111.252 52.0612 111.427 51.1859 111.504 50.2994L110.824 48.9395Z"
          fill="url(#paint3_linear_10664_23905)"
        />
        <path
          d="M112.164 51.5692C112.076 52.3254 111.874 53.0639 111.564 53.7592C111.364 53.9092 111.114 53.8191 111.034 53.4191C111.092 52.4772 111.222 51.5411 111.424 50.6191L112.164 51.5692Z"
          fill="url(#paint4_linear_10664_23905)"
        />
        <path
          d="M113.964 57.1094L114.964 56.6094L110.594 47.6094C110.322 47.743 110.113 47.9788 110.014 48.2653C109.915 48.5519 109.933 48.866 110.064 49.1394L113.964 57.1094Z"
          fill="#022C52"
        />
        <path
          d="M124.944 39.0203C124.324 36.2203 123.724 33.3902 125.354 30.3202C125.953 29.1496 126.837 28.148 127.923 27.4072C129.01 26.6664 130.265 26.2102 131.574 26.0802C139.024 25.1902 137.434 32.1503 147.854 33.6603C151.094 34.1303 154.104 34.5802 156.854 36.1902C161.744 39.1002 163.584 43.7602 160.344 51.3602C152.414 69.9802 132.954 54.1802 130.554 50.5102C128.714 47.7902 125.344 40.8203 124.944 39.0203Z"
          fill="#022C52"
        />
        <path
          d="M154.774 156.57C154.774 156.57 155.304 161.96 156.674 162.95C158.044 163.94 159.854 167.6 158.944 169.58C158.794 169.874 158.582 170.131 158.323 170.335C158.065 170.539 157.765 170.684 157.444 170.76C156.513 171.028 155.515 170.949 154.638 170.537C153.761 170.125 153.063 169.408 152.674 168.52C152.104 167.222 151.785 165.827 151.734 164.41C151.73 162.115 151.193 159.852 150.164 157.8L154.774 156.57Z"
          fill="url(#paint5_linear_10664_23905)"
        />
        <path
          d="M133.774 158.789C133.557 161.183 133.527 163.59 133.684 165.989C133.874 166.989 134.914 168.889 134.444 169.779C134.238 170.247 133.888 170.636 133.444 170.889L121.064 171.089C120.394 171.089 120.834 170.669 121.374 170.269C122.775 169.303 124.269 168.479 125.834 167.809C126.014 167.719 126.694 167.299 126.934 167.149C127.593 166.713 128.188 166.188 128.704 165.589C129.594 164.589 129.704 159.809 129.704 159.809L133.774 158.789Z"
          fill="url(#paint6_linear_10664_23905)"
        />
        <path
          d="M124.114 86.4694C124.114 86.4694 122.554 95.2994 123.574 101.099C124.594 106.899 129.514 160.559 129.514 160.559L134.974 160.869C134.974 160.869 136.124 138.449 135.914 135.329C135.556 132.501 134.947 129.71 134.094 126.989L134.634 108.889L127.774 85.1094L124.114 86.4694Z"
          fill="url(#paint7_linear_10664_23905)"
        />
        <path
          d="M140.164 84.5703C140.164 84.5703 144.464 91.0303 145.484 96.3803C146.504 101.73 144.734 118.15 146.704 125.16C147.774 128.95 151.814 134.8 152.424 139.7C153.034 144.6 155.424 157.44 155.424 157.44L149.974 158.52L137.284 126.46L127.284 97.4603L124.774 82.5703L140.164 84.5703Z"
          fill="url(#paint8_linear_10664_23905)"
        />
        <path
          d="M136.684 47.8594C138.937 48.1652 141.036 49.1728 142.684 50.7394C144.944 53.1894 139.044 72.8894 138.634 75.9994C138.224 79.1094 141.994 86.3994 141.994 86.3994C141.994 86.3994 127.924 88.9994 124.104 86.4694C124.104 86.4694 123.694 64.0494 124.104 61.8194C124.514 59.5894 127.924 50.5394 128.744 49.6494C129.564 48.7594 136.684 47.8594 136.684 47.8594Z"
          fill="#022C52"
        />
        <path
          d="M142.004 52.5709C141.912 52.3135 141.769 52.0776 141.583 51.8776C141.397 51.6777 141.172 51.518 140.922 51.4084C140.672 51.2988 140.402 51.2415 140.129 51.2403C139.855 51.239 139.585 51.2937 139.334 51.4009C137.446 52.1311 135.875 53.5007 134.894 55.2709C133.254 58.6809 127.524 70.4109 125.754 70.8609C123.984 71.3109 116.754 58.6809 116.754 58.6809C116.866 57.5016 116.726 56.3121 116.344 55.1909C115.724 53.9309 113.884 52.6009 113.614 53.0409C113.344 53.4809 114.614 54.6009 114.614 54.8209C114.614 55.0409 114.064 55.1909 113.314 54.7509C112.816 54.412 112.419 53.9458 112.164 53.4009C111.82 54.0568 111.646 54.7881 111.656 55.5285C111.667 56.2688 111.862 56.9949 112.224 57.6409C113.524 59.6409 114.064 60.4709 114.064 60.4709C114.064 60.4709 122.464 79.1009 125.534 79.3209C128.404 79.5709 144.884 61.2809 142.004 52.5709Z"
          fill="url(#paint9_linear_10664_23905)"
        />
        <path
          d="M134.774 40.27L134.854 40.7299C135.286 43.159 135.921 45.5475 136.754 47.8699C137.544 49.3699 134.014 54.17 130.624 53.59C129.624 53.41 131.474 49.1799 131.384 48.7299C131.214 47.8699 130.984 46.7299 130.744 45.4999C130.604 44.8199 130.474 44.1299 130.344 43.4999C129.984 41.6699 129.684 40.1699 129.684 40.1699L134.774 40.27Z"
          fill="url(#paint10_linear_10664_23905)"
        />
        <path
          opacity="0.16"
          d="M134.864 40.7303L134.784 40.2704L129.694 40.1504C129.694 40.1504 129.994 41.6503 130.354 43.4803C130.484 44.1303 130.614 44.8103 130.754 45.4803C131.664 45.322 132.509 44.9015 133.184 44.2704C134.021 43.5291 134.654 42.5858 135.024 41.5304C134.964 41.2104 134.904 40.9403 134.864 40.7303Z"
          fill="#022C52"
        />
        <path
          d="M131.774 28.1707C133.198 28.4563 134.47 29.2486 135.354 30.4007C136.854 32.3407 138.474 38.3507 134.744 41.6107C131.014 44.8707 127.314 41.1807 126.744 37.2607C126.174 33.3407 126.284 28.0307 131.774 28.1707Z"
          fill="url(#paint11_linear_10664_23905)"
        />
        <path
          d="M125.524 35.9293C125.964 36.7893 126.714 37.2693 127.194 36.9993C127.674 36.7293 127.694 35.7993 127.254 34.9293C126.814 34.0593 126.054 33.5893 125.574 33.8593C125.094 34.1293 125.074 35.0593 125.524 35.9293Z"
          fill="url(#paint12_linear_10664_23905)"
        />
        <path
          d="M131.094 28.0808C131.094 28.0808 134.294 33.7908 136.594 34.0808C138.894 34.3708 139.184 37.3708 139.184 37.3708C139.184 37.3708 138.364 30.3709 136.094 29.0309C134.563 28.2109 132.818 27.8794 131.094 28.0808Z"
          fill="#022C52"
        />
        <path
          d="M135.844 35.419C135.654 36.419 136.024 37.359 136.674 37.489C137.324 37.619 138.004 36.9091 138.194 35.8991C138.384 34.8891 138.004 33.899 137.354 33.819C136.704 33.739 136.024 34.399 135.844 35.419Z"
          fill="url(#paint13_linear_10664_23905)"
        />
        <path
          d="M152.294 167.57C153.428 167.76 154.593 167.627 155.654 167.184C156.715 166.742 157.63 166.009 158.294 165.07C159.054 166.54 159.514 168.38 158.954 169.59C158.394 170.8 157.134 170.95 155.954 170.99C155.371 171.013 154.793 170.875 154.283 170.591C153.773 170.307 153.352 169.888 153.064 169.38C152.748 168.804 152.491 168.197 152.294 167.57Z"
          fill="#022C52"
        />
        <path
          d="M126.924 167.149C129.228 167.798 131.679 167.7 133.924 166.869C134.274 167.869 134.734 169.099 134.494 169.809C134.194 170.689 133.764 170.879 133.384 170.889C130.384 170.969 122.384 171.079 120.144 171.109C120.073 171.109 120.004 171.088 119.945 171.05C119.886 171.012 119.838 170.958 119.809 170.893C119.78 170.829 119.769 170.758 119.779 170.688C119.789 170.618 119.818 170.553 119.864 170.499C120.474 169.819 126.684 167.289 126.924 167.149Z"
          fill="#022C52"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_10664_23905"
          x1="0.0864258"
          y1="67.553"
          x2="135.125"
          y2="67.553"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00FFFF" />
          <stop offset="1" stop-color="#0081FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10664_23905"
          x1="110.844"
          y1="59.9807"
          x2="129.504"
          y2="59.9807"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00FFFF" />
          <stop offset="1" stop-color="#0081FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10664_23905"
          x1="5260.43"
          y1="1755.15"
          x2="5272.82"
          y2="1755.15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00FFFF" />
          <stop offset="1" stop-color="#0081FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_10664_23905"
          x1="1777.7"
          y1="2389.04"
          x2="1779.04"
          y2="2389.04"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00FFFF" />
          <stop offset="1" stop-color="#0081FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_10664_23905"
          x1="1764.51"
          y1="1842.91"
          x2="1765.8"
          y2="1842.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00FFFF" />
          <stop offset="1" stop-color="#0081FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_10664_23905"
          x1="13710.4"
          y1="9771.03"
          x2="13791.9"
          y2="9771.03"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00FFFF" />
          <stop offset="1" stop-color="#0081FF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_10664_23905"
          x1="20506.2"
          y1="8416.67"
          x2="20698.1"
          y2="8416.67"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00FFFF" />
          <stop offset="1" stop-color="#0081FF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_10664_23905"
          x1="123.224"
          y1="122.989"
          x2="135.944"
          y2="122.989"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#000044" />
          <stop offset="0.05" stop-color="#000044" />
          <stop offset="0.2" stop-color="#090963" />
          <stop offset="1" stop-color="#3834FF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_10664_23905"
          x1="45395.8"
          y1="47704"
          x2="46334.9"
          y2="47704"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#000044" />
          <stop offset="0.05" stop-color="#000044" />
          <stop offset="0.2" stop-color="#090963" />
          <stop offset="1" stop-color="#3834FF" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_10664_23905"
          x1="45029.6"
          y1="16107.2"
          x2="45971.6"
          y2="16107.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00FFFF" />
          <stop offset="1" stop-color="#0081FF" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_10664_23905"
          x1="10772.8"
          y1="7492.5"
          x2="10824.4"
          y2="7492.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00FFFF" />
          <stop offset="1" stop-color="#0081FF" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_10664_23905"
          x1="15671.2"
          y1="7992.46"
          x2="15781.4"
          y2="7992.46"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00FFFF" />
          <stop offset="1" stop-color="#0081FF" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_10664_23905"
          x1="3626.54"
          y1="1817.22"
          x2="3632.13"
          y2="1817.22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00FFFF" />
          <stop offset="1" stop-color="#0081FF" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_10664_23905"
          x1="3779.78"
          y1="2035.14"
          x2="3785.76"
          y2="2035.14"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00FFFF" />
          <stop offset="1" stop-color="#0081FF" />
        </linearGradient>
        <clipPath id="clip0_10664_23905">
          <rect
            width="51.93"
            height="145.11"
            fill="white"
            transform="translate(109.984 26)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DrawerError;
